import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
	// eslint-disable-next-line @angular-eslint/component-selector
	selector: 'lu-button-input',
	templateUrl: './lu-button-input.component.html',
	styleUrls: ['./lu-button-input.component.scss']
})

// Place holder for LuButtonInput. This is based on LuInput and needs to be implemented.
// See https://getbootstrap.com/docs/4.0/components/input-group/#button-addons
export class LuButtonInputComponent extends FieldType {
	get type(): string {
		return this.to.type || 'text';
	}
}
